<template>
    <OverlayLoader :isLoading="!clientLoaded">
        <main class="page page-dashboard">
            <div class="container">
                <PageHeader
                    :title="$translate.text('clients.company')"
                />

                <!-- <p>{{ t('clients.company.text') }}</p> -->

                <MyCompanyMenu></MyCompanyMenu>


                <Alert :show="client.has_minox_exception" type="danger" style="display: flex; flex-direction: column;">
                    <p class="alert-title">We receivid an error message from our accounting software</p>
                    <span style="margin-top: 2px;">{{ client.minox_exception_message}} Please double-check the information you entered and try again.</span>
                </Alert>

                <form @submit.prevent="submitForm" method="POST">
                    <h4>{{ client.company_name }}</h4>

                    <TextInput
                        id="companyName"
                        :value="client.company_name"
                        name="companyName"
                        @change="client.company_name = $event"
                        :label="$translate.text('general.company.name')"
                        required
                    />

                    <TextInput
                        id="street"
                        :value="client.street"
                        name="street"
                        @change="client.street = $event"
                        :label="$translate.text('general.address.street')"
                        required
                    />

                    <TextInput
                        id="zipcode"
                        :value="client.zipcode"
                        name="zipcode"
                        @change="client.zipcode = $event"
                        :label="$translate.text('general.address.zipcode')"
                        required
                    />

                    <TextInput
                        id="city"
                        :value="client.city"
                        name="city"
                        @change="client.city = $event"
                        :label="$translate.text('general.address.city')"
                        required
                    />

                    <Select
                        v-if="countriesLoaded"
                        id="countries"
                        :value="client.country"
                        name="countries"
                        @change="client.country = $event"
                        :options="countriesSelectValues"
                        :label="$translate.text('general.address.country')"
                        :required="true"
                    />

                    <Select
                        v-if="countriesLoaded"
                        id="states"
                        :value="client.state_id"
                        name="states"
                        @change="client.state_id = $event"
                        :options="statesSelectedValues"
                        :label="$translate.text('general.address.state')"
                        :required="true"
                    />

                    <TextInput
                        id="contact_name"
                        :value="client.contact_name"
                        name="phone"
                        @change="client.contact_name = $event"
                        :label="$translate.text('general.contact.name')"
                        required
                    />

                    <TextInput
                        id="phone"
                        :value="client.phone"
                        name="phone"
                        @change="client.phone = $event"
                        :label="$translate.text('general.contact.phone')"
                        required
                    />

                    <EmailInput
                        id="email"
                        :value="client.email"
                        name="email"
                        @change="client.email = $event"
                        :label="$translate.text('general.contact.email')"
                        required
                    />

                    <TextInput
                        id="website"
                        :value="client.website"
                        name="website"
                        @change="client.website = $event"
                        :label="$translate.text('general.company.website')"
                        :placeholder="`https://website.com`"
                    />

                    <h4>{{ t('general.extra_information') }}</h4>

                    <TextInput
                        id="kvk"
                        :value="client.kvk"
                        name="kvk"
                        @change="client.kvk = $event"
                        :label="$translate.text('general.company.chamber_of_commerce')"
                        required
                    />

                    <TextInput
                        id="btw"
                        :value="client.btw"
                        name="btw"
                        @change="client.btw = $event"
                        :label="$translate.text('general.company.vat_number')"
                        required
                    />

                    <FormSubmit
                        :buttonLabel="submittingIsLoading ? $translate.text('general.save_changes.saving') :  $translate.text('general.save_changes')"
                        :disabled="submittingIsLoading"
                    />
                </form>
            </div>
        </main>
    </OverlayLoader>
</template>
<script>
// import Alert from '@/components/Alert/Alert';
import swal from 'sweetalert';

import PageHeader from '@/components/PageHeader/PageHeader';
import TextInput from '@/components/Inputs/TextInput';
import EmailInput from '@/components/Inputs/EmailInput';
import FormSubmit from '@/components/Forms/FormSubmit';
import OverlayLoader from '@/components/OverlayLoader/OverlayLoader';
import MyCompanyMenu from '@/components/MyCompanyMenu/MyCompanyMenu';

import { get, put } from '@/helpers/http';
import handleError from '@/helpers/error';
import Select from '@/components/Inputs/Select.vue';
import Alert from '@/components/Alert/Alert.vue';


export default {
    name: 'MyCompany',

    components: {
        Alert,
        Select,
        // Alert,
        MyCompanyMenu,
        PageHeader,
        TextInput,
        EmailInput,
        FormSubmit,
        OverlayLoader,
    },

    data() {
        return {
            client: {},
            clientLoaded: false,
            countries: [],
            countriesLoaded: false,
            submittingIsLoading: false,
        };
    },

    created() {
        this.getClient();
        this.getCountries();
    },

    methods: {
        getClient() {
            get({
                url: `${this.$API_URL}/api/auth/company`,
            })
                .then((response) => {
                    this.client = response.data.data;
                    this.clientLoaded = true;
                })
                .catch((error) => {
                    handleError({
                        error,
                        message: this.$translate.text('alert.whoops'),
                    });
                });
        },

        getCountries() {
            get({
                url: `${this.$API_URL}/api/countries`,
            })
                .then((response) => {
                    this.countries = response.data.data;
                    this.countriesLoaded = true;
                })
                .catch((error) => {
                    handleError({
                        error,
                        message: this.$translate.text('alert.whoops'),
                    });
                });
        },

        submitForm() {
            this.submittingIsLoading = true;
            this.client.phone = this.client.phone === null ? null : this.client.phone.toString();

            put({
                url: `${this.$API_URL}/api/auth/company`,
                data: {
                    ...this.client,
                },
            })
                .then(async () => {
                    /*
                        First we call the getUser call, which will update
                        the user in the localStorage. After that, we'll
                        get the client again to update the setup_completed field
                    */
                    await this.$http.getUser();
                    this.getClient();
                    this.submittingIsLoading = false;

                    swal({
                        title: this.$translate.text('alert.success'),
                        text: this.$translate.text('alert.success.message.saved'),
                    });
                })
                .catch((error) => {
                    handleError({
                        error,
                        message: this.$translate.text('alert.whoops'),
                    });

                    this.submittingIsLoading = false;
                });
        },
    },

    watch: {
        statesSelectedValues(newValues, oldValues) {
            this.client.state_id = newValues[1].value;
        },
    },
    computed: {
        countriesSelectValues() {
            const countries = [{
                label: this.$translate.text('general.select_option'),
                value: null,
                disabled: true,
            }];

            this.countries.forEach((country) => {
                countries.push({
                    value: country.id,
                    label: country.name,
                });
            });
            return countries;
        },
        statesSelectedValues() {
            if (this.client.country === null) {
                return [];
            }

            const country = this.countries.find((country) => country.id == this.client.country);

            if (!country) {
                return [];
            }

            const states = [{
                label: this.$translate.text('general.select_option'),
                value: null,
                disabled: true,
            }];

            this.countries.find((tmpCountry) => tmpCountry.id == this.client.country).states.forEach((state) => {
                states.push({
                    value: state.id,
                    label: state.name,
                });
            });

            return states;
        },
    },
};
</script>
<style lang="scss" scoped>
.alert {
    margin-bottom: 0;
}

form {
    padding-top: 24px;
}

.alert-title {
    color: $color-danger-dark;
    font-size: 16px;
    font-weight: bold;
    line-height: 22px;
}
</style>
